module.exports = __webpack_public_path__ + "static/assets/74496d9086d97aaeeafb3085e9957668.ttf";